import { Fade } from "react-awesome-reveal";
import { AiFillMessage } from "react-icons/ai";
import { INPUTS } from "./inputsForm";

export default function Form({ sendEmail, form, value }) {
  return (
    <form ref={form} onSubmit={sendEmail} className="w-[500px] max-w-full space-y-4">
      {/* animation */}
      <Fade cascade damping={0.2}>
        {/* *********************************************************************************************************** */}

        {INPUTS.map((inp) => (
          <div className="relative" key={inp.id}>
            <input
              type={inp.type}
              placeholder={inp.placeholder}
              name={inp.name}
              className="h-12 sp-input"
              value={value.inputVal}
              required
            />
            {inp.icon}
          </div>
        ))}

        {/* *********************************************************************************************************** */}

        <div className="relative">
          <textarea
            placeholder="Message"
            className="pt-3 h-32 resize-none sp-textarea"
            name="message"
            value={value.inputVal}
            required
          ></textarea>
          <AiFillMessage fontSize={20} className="absolute top-4 left-4" />
        </div>

        {/* *********************************************************************************************************** */}

        <button type="submit" className="sp-button-components">
          Submit
        </button>
      </Fade>
    </form>
  );
}
